import type { TopMoversReport } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { ReportFilters } from './useReportFilters';

export const topMoversKeys = {
  report: (filters: ReportFilters, limit: number) => ['reports', 'top-movers', filters, limit] as const,
};

export function fetchTopMovers(filters: ReportFilters, limit: number, signal?: AbortSignal): Promise<TopMoversReport> {
  const qs = queryString({ branchId: filters.branchId, from: filters.from, to: filters.to, limit });
  return portalApi.get<TopMoversReport>(`/portal/reports/top-movers${qs}`, { signal });
}
